import { Seller, User } from "types";

const snippets: Array<{ name: string; register: (user: User, seller: Seller, isXchatEnabled: boolean) => void }> = [];

export const registerSnippet = (
    name: string,
    enable: boolean,
    register: (user: User, seller: Seller, isXchatEnabled: boolean) => void,
) => {
    if (enable) {
        snippets.push({ name, register });
    }
};

export const loadSnippets = (user: User, seller: Seller, isXchatEnabled = true) => {
    for (const { register } of snippets) {
        register(user, seller, isXchatEnabled);
    }
};

export const hasRegisteredSnippet = (name: string) => {
    return snippets.some((snippet) => snippet.name === name);
};

export const loadSnippet = (snippetName: string, user: User, seller: Seller, isXchatEnabled = true) => {
    for (const { register, name } of snippets) {
        if (name === snippetName) {
            register(user, seller, isXchatEnabled);
        }
    }
};
